interface GuardedStorage {
  getItem: (name: string) => string | null;
  setItem: (name: string, value: string) => void;
  removeItem: (name: string) => void;
}

let isSealed = false;

export const sealPersistentStorage = (): void => {
  isSealed = true;
};

export const unsealPersistentStorage = (): void => {
  isSealed = false;
};

export const guardedLocalStorage: GuardedStorage = {
  getItem: name => localStorage.getItem(name),
  setItem: (name, value) => {
    if (isSealed) {
      return;
    }

    localStorage.setItem(name, value);
  },
  removeItem: name => localStorage.removeItem(name),
};
